import React from "react";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import FeatureItem from "./featureItem";
import FeatureItemSlide from "./featureItemSlide";
import * as styles from './infographic.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

let owlClass = "listing-owl listing-owl--shadow listing-owl--marked " + styles.mobileFeatures;

const options = {
    items: 1,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: false,
    margin: 14,
    stagePadding: 47,
    responsive: {
        0 : {
            items: 1
        },
        450: {
            stagePadding: 67
        },
        540: {
            stagePadding: 87
        },
        650: {
            items: 2,
            stagePadding: 47
        }
    }
};


function Infographic(props) {

    const featuredimg = maybeImage(props.featuredimage);
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={styles.sectionInfographic} style={{ backgroundColor: `${bgColor}`}}>
            <div className={styles.sectionContainer}>

                <div className={styles.desktopWrapper}>
                    <div className={styles.contentCell}>
                        {
                            props.features.map((item, i) => {  
                                return <FeatureItem item={item} key={i} />
                            })
                        }
                    </div>
                    <div className={styles.featuredCell}>
                        {featuredimg}
                    </div>
                </div>

                <div className={styles.mobileWrapper}>

                    <div className={owlClass}>

                        <OwlCarousel options={options}>
                            
                            {
                                props.features.map((item, i) => {  
                                    return <FeatureItemSlide item={item} key={i} />
                                })
                            }

                        </OwlCarousel>
                    
                    </div>
                    
                </div>

            </div>
        </div>
    );
}
  
export default Infographic;